import { render, staticRenderFns } from "./AdvisorProfile.vue?vue&type=template&id=5ff726de&scoped=true&"
import script from "./AdvisorProfile.vue?vue&type=script&lang=js&"
export * from "./AdvisorProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorProfile.vue?vue&type=style&index=0&id=5ff726de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff726de",
  null
  
)

export default component.exports